export default __webpack_public_path__ + "static/sprites-8c6b46d127d3888923978e8e4c1e0aa0.svg";